import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { Category } from '../models/category';
import { CategoryResponse } from './models/category-response';
import {
  ServiceCallOptions,
  useCallOptions,
} from './models/service-call-options';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  constructor(private http: HttpClient) {}

  getCategories(
    withBadgesOnly = true,
    options?: ServiceCallOptions
  ): Observable<Category[]> {
    return this.http
      .get<CategoryResponse[]>(
        `${environment.apiBaseUrl}/categories?withBadgesOnly=${withBadgesOnly}`,
        useCallOptions(options)
      )
      .pipe(
        map((response) =>
          response.map((category) => ({
            ...category,
            id: String(category.id),
            badges: category.badges.map((badge) => ({
              ...badge,
              id: String(badge.id),
              categoryId: String(badge.categoryId),
            })),
          }))
        )
      );
  }

  upsertCategory(
    category: Category,
    options?: ServiceCallOptions
  ): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/categories`,
      { category },
      useCallOptions(options)
    );
  }

  deleteCategory(
    categoryId: string,
    options?: ServiceCallOptions
  ): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiBaseUrl}/categories/${categoryId}`,
      useCallOptions(options)
    );
  }

  reorderCategory(
    from: number,
    to: number,
    options?: ServiceCallOptions
  ): Observable<void> {
    return this.http.post<void>(
      `${environment.apiBaseUrl}/categories/reorder`,
      { from, to },
      useCallOptions(options)
    );
  }
}
